import React from 'react';
import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { useDrag } from 'react-dnd';
import { WidgetPaletteItemProps, DragItem } from '../types';
import { ITEM_TYPE } from '../constants';

export const WidgetPaletteItem: React.FC<WidgetPaletteItemProps> = ({ definition }) => {
    const [{ isDragging }, drag] = useDrag(() => ({
        type: ITEM_TYPE,
        item: { type: ITEM_TYPE, widgetType: definition.type, isNew: true } as DragItem,
        collect: (monitor) => ({
            isDragging: monitor.isDragging()
        })
    }));

    return (
        <ListItem
            ref={drag}
            sx={{
                cursor: 'grab',
                opacity: isDragging ? 0.5 : 1,
                '&:hover': {
                    backgroundColor: 'action.hover'
                }
            }}
        >
            <ListItemIcon sx={{ color: 'primary.main' }}>
                {definition.icon}
            </ListItemIcon>
            <ListItemText
                primary={definition.name}
                secondary={definition.description}
                secondaryTypographyProps={{
                    fontSize: '0.75rem',
                    color: 'text.secondary'
                }}
            />
        </ListItem>
    );
};